import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getTextSettings = function getTextSettings(options) {
  if (_typeof(options) === 'object' && options !== null && 'text' in options) {
    return _objectSpread(_objectSpread({}, options), {}, {
      rows: options.truncate ? options.rows || 1 : undefined
    });
  }
  return {
    text: options,
    truncate: false
  };
};
export var getColor = function getColor(disabled, defaultColor, color) {
  if (disabled) {
    return 'tertiary';
  }
  if (color) {
    return color;
  }
  return defaultColor || 'primary';
};